import { RCButtons } from '@/Components/DeviceInventory/helpers';
import PropTypes from 'prop-types';

export const RCNavigation = ({
  className = '',
  style = {},
  isSelected = false,
  button = '',
  buttonPressedFromPortal = '',
  onMouseDown,
  onMouseUp,
}) => (
  <svg
    className={className}
    style={style}
    width="119"
    height="119"
    viewBox="0 0 119 119"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_18891_160228)">
      <path
        d="M71.1025 4.1875H47.8744C45.6423 4.1875 43.5962 5.11755 42.1081 6.58238C40.62 8.07046 39.7132 10.0933 39.7132 12.3487V36.8788C39.7132 38.4599 38.4344 39.7387 36.8533 39.7387H12.3465C10.1144 39.7387 8.06826 40.6687 6.58018 42.1336C5.0921 43.6217 4.1853 45.6445 4.1853 47.8999V71.1279C4.1853 73.36 5.11535 75.4061 6.58018 76.8942C8.04501 78.3823 10.0911 79.2891 12.3465 79.2891H36.8766C38.4577 79.2891 39.7365 80.5679 39.7365 82.149V106.679C39.7365 108.911 40.6666 110.957 42.1314 112.445C43.5962 113.934 45.6423 114.84 47.8977 114.84H71.1257C73.3578 114.84 75.4039 113.91 76.892 112.445C78.3801 110.957 79.2869 108.934 79.2869 106.679V82.149C79.2869 80.5679 80.54657 79.2891 82.1468 79.2891H106.677C108.909 79.2891 110.955 78.3591 112.443 76.8942C113.931 75.4061 114.838 73.3833 114.838 71.1279V47.8999C114.838 45.6678 113.908 43.6217 112.443 42.1336C110.955 40.6455 108.932 39.7387 106.677 39.7387H82.1468C80.5657 39.7387 79.2869 38.4599 79.2869 36.8788V12.3487C79.2869 10.1166 78.3569 8.07046 76.892 6.58238C75.4039 5.0943 73.3811 4.1875 71.1257 4.1875H71.1025ZM41.4338 59.5023C41.4338 49.5275 49.5253 41.436 59.5001 41.436C69.4749 41.436 77.5663 49.5275 77.5663 59.5023C77.5663 69.4771 69.4749 77.5685 59.5001 77.5685C49.5253 77.5685 41.4338 69.4771 41.4338 59.5023Z"
        fill="#1C1C1C"
      />
      <path
        d="M71.1024 4.18523C73.3345 4.18523 75.3806 5.11528 76.8687 6.58011C78.3568 8.06819 79.2636 10.0911 79.2636 12.3464V36.8765C79.2636 38.4576 80.5424 39.7364 82.1235 39.7364H106.654C108.886 39.7364 110.932 40.6665 112.42 42.1313C113.908 43.6194 114.815 45.6422 114.815 47.8976V71.1256C114.815 73.3578 113.885 75.4039 112.42 76.892C110.932 78.38 108.909 79.2868 106.654 79.2868H82.1235C80.5424 79.2868 79.2636 80.5657 79.2636 82.1467V106.677C79.2636 108.909 78.3335 110.955 76.8687 112.443C75.3806 113.931 73.3578 114.838 71.1024 114.838H47.8744C45.6422 114.838 43.5961 113.908 42.1081 112.443C40.62 110.955 39.7132 108.932 39.7132 106.677V82.1467C39.7132 80.5657 38.4344 79.2868 36.8533 79.2868H12.3464C10.1143 79.2868 8.06819 78.3568 6.58011 76.892C5.09203 75.4039 4.18523 73.381 4.18523 71.1256V47.8976C4.18523 45.6655 5.11528 43.6194 6.58011 42.1313C8.06819 40.6432 10.0911 39.7364 12.3464 39.7364H36.8765C38.4576 39.7364 39.7364 38.4576 39.7364 36.8765V12.3464C39.7364 10.1143 40.6665 8.06819 42.1313 6.58011C43.6194 5.09203 45.6422 4.18523 47.8976 4.18523H71.1256M59.5 77.543C69.4748 77.543 77.5662 69.4515 77.5662 59.4768C77.5662 49.502 69.4748 41.4105 59.5 41.4105C49.5252 41.4105 41.4338 49.502 41.4338 59.4768C41.4338 69.4515 49.5252 77.543 59.5 77.543ZM71.1024 0H47.8744C44.5959 0 41.5035 1.27882 39.1551 3.6272C36.83 5.97558 35.5279 9.068 35.5279 12.3464V35.5512H12.3464C9.068 35.5512 5.97558 36.83 3.6272 39.1784C1.30207 41.5035 0 44.6192 0 47.8976V71.1256C0 74.4041 1.27882 77.4965 3.6272 79.8449C5.95233 82.17 9.068 83.4721 12.3464 83.4721H35.5512V106.677C35.5512 109.955 36.83 113.048 39.1784 115.396C41.5035 117.721 44.6192 119.023 47.8976 119.023H71.1256C74.4041 119.023 77.4965 117.744 79.8449 115.396C82.17 113.071 83.4721 109.955 83.4721 106.677V83.4721H106.677C109.955 83.4721 113.048 82.1932 115.396 79.8449C117.721 77.5197 119.023 74.4041 119.023 71.1256V47.8976C119.023 44.6192 117.744 41.5268 115.396 39.1784C113.048 36.83 109.955 35.5512 106.677 35.5512H83.4721V12.3464C83.4721 9.068 82.1932 5.97558 79.8449 3.6272C77.5197 1.30207 74.4041 0 71.1256 0L71.1024 0ZM59.5 73.3578C51.8503 73.3578 45.619 67.1264 45.619 59.4768C45.619 51.8271 51.8503 45.5957 59.5 45.5957C67.1497 45.5957 73.381 51.8271 73.381 59.4768C73.381 67.1264 67.1497 73.3578 59.5 73.3578Z"
        fill="white"
      />
      <rect
        x="87"
        y="42"
        width="27"
        height="35"
        fill="transparent"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowRight)}
        onMouseUp={onMouseUp}
      />
      <path
        d="M95.7488 71.2939C95.214 71.2939 94.6793 71.0847 94.2607 70.6894C93.4469 69.8756 93.4469 68.5503 94.2607 67.7365L102.468 59.5288L94.2607 51.3211C93.4469 50.5073 93.4469 49.182 94.2607 48.3682C95.0745 47.5544 96.3999 47.5544 97.2136 48.3682L108.374 59.5288L97.2136 70.6894C96.7951 71.1079 96.2603 71.2939 95.7256 71.2939H95.7488Z"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowRight)}
        onMouseUp={onMouseUp}
        className={
          (isSelected && button === RCButtons.RCArrowRight) ||
          buttonPressedFromPortal === RCButtons.RCArrowRight
            ? 'navigation-selected'
            : 'navigation-default'
        }
      />
      <rect
        x="6"
        y="42"
        width="27"
        height="35"
        fill="transparent"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowLeft)}
        onMouseUp={onMouseUp}
      />
      <path
        d="M22.9024 71.2939C22.3676 71.2939 21.8328 71.0847 21.4143 70.6894L10.2537 59.5288L21.4143 48.3682C22.2281 47.5544 23.5534 47.5544 24.3672 48.3682C25.181 49.182 25.181 50.5073 24.3672 51.3211L16.1595 59.5288L24.3672 67.7365C25.181 68.5503 25.181 69.8756 24.3672 70.6894C23.9487 71.1079 23.4139 71.2939 22.8791 71.2939H22.9024Z"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowLeft)}
        onMouseUp={onMouseUp}
        className={
          (isSelected && button === RCButtons.RCArrowLeft) ||
          buttonPressedFromPortal === RCButtons.RCArrowLeft
            ? 'navigation-selected'
            : 'navigation-default'
        }
      />
      <rect
        x="43"
        y="6"
        width="35"
        height="27"
        fill="transparent"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowUp)}
        onMouseUp={onMouseUp}
      />
      <path
        d="M49.595 24.7649C49.0602 24.7649 48.5255 24.5557 48.1069 24.1604C47.2931 23.3466 47.2931 22.0213 48.1069 21.2075L59.2675 10.0469L70.4281 21.2075C71.2419 22.0213 71.2419 23.3466 70.4281 24.1604C69.6144 24.9742 68.289 24.9742 67.4752 24.1604L59.2675 15.9527L51.0598 24.1604C50.6413 24.5789 50.1065 24.7649 49.5718 24.7649H49.595Z"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowUp)}
        onMouseUp={onMouseUp}
        className={
          (isSelected && button === RCButtons.RCArrowUp) ||
          buttonPressedFromPortal === RCButtons.RCArrowUp
            ? 'navigation-selected'
            : 'navigation-default'
        }
      />
      <rect
        x="43"
        y="87"
        width="35"
        height="27"
        fill="transparent"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowDown)}
        onMouseUp={onMouseUp}
      />
      <path
        d="M59.2907 108.165L48.1301 97.0047C47.3163 96.1909 47.3163 94.8655 48.1301 94.0518C48.9439 93.238 50.2692 93.238 51.083 94.0518L59.2907 102.259L67.4984 94.0518C68.3122 93.238 69.6375 93.238 70.4513 94.0518C71.2651 94.8655 71.2651 96.1909 70.4513 97.0047L59.2907 108.165Z"
        style={{ cursor: 'pointer' }}
        onMouseDown={() => onMouseDown(RCButtons.RCArrowDown)}
        onMouseUp={onMouseUp}
        className={
          (isSelected && button === RCButtons.RCArrowDown) ||
          buttonPressedFromPortal === RCButtons.RCArrowDown
            ? 'navigation-selected'
            : 'navigation-default'
        }
      />
    </g>
    <defs>
      <clipPath id="clip0_18891_160228">
        <rect width="119" height="119" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

RCNavigation.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isSelected: PropTypes.bool,
  button: PropTypes.string,
  buttonPressedFromPortal: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
};
